import { dtDate } from './helper'

export function isSomeDay(tsOne: number, tsSecond: number): boolean {
    return dtDate(tsOne).toLocaleDateString() == dtDate(tsSecond).toLocaleDateString()
}